var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { isGatewayCardOrProgram } from '@Utils/gatewayCards';
import { toast } from 'react-toastify';
import { CancelCardModal } from '@ReactComponents/CancelCardModal';
import { ConfirmModal } from '@ReactComponents/ConfirmModal';
import { CardsGatewayIssuingModalConnected } from '@ReactComponents/Cards/CardsGatewayIssuingModal/CardsGatewayIssuingModal';
import { CardTrackingDetailsModal } from '@ReactComponents/Cards/Components/CardTrackingDetailsModal/CardTrackingDetailsModal';
import { parseAndGetErrorMessage } from '@ReactComponents/Shared/ErrorAlert';
import { CardIssuingApiService } from '@ClientApi/cardIssuing';
import { LinkedAccountsApiService } from '@ClientApi/linkedAccounts';
import { TransactionsApi } from '@ClientApi/transactionsApi';
import { CARD_TX_STATE, CARD_TX_STATE_VALUES } from '@Shared/constants';
import { AddCapabilities } from './cardsActions';
import { CloseModal, ShowModal } from './modalActions';
export const CARD_PAGE_SET_CARD_DETAILS = 'CARD_PAGE_SET_CARD_DETAILS';
export const CARD_PAGE_SET_CARD_STATE = 'CARD_PAGE_SET_CARD_STATE';
export const CARD_PAGE_SET_LOADING = 'CARD_PAGE_SET_LOADING';
export const CARD_PAGE_SET_TRANSACTIONS = 'CARD_PAGE_SET_TRANSACTIONS';
export class SetLoading {
    constructor(loading) {
        this.type = CARD_PAGE_SET_LOADING;
        this.payload = loading;
    }
}
export class SetCardDetails {
    constructor(details) {
        this.details = details;
        this.type = CARD_PAGE_SET_CARD_DETAILS;
        this.payload = details;
    }
}
export class SetCardTransactions {
    constructor(rows, count) {
        this.rows = rows;
        this.count = count;
        this.type = CARD_PAGE_SET_TRANSACTIONS;
        this.payload = { rows, count };
    }
}
export class SetCardState {
    constructor(state) {
        this.state = state;
        this.type = CARD_PAGE_SET_CARD_STATE;
        this.payload = state;
    }
}
export const init = (id) => (dispatch, getState) => __awaiter(void 0, void 0, void 0, function* () {
    const capabilitiesMap = getState().cards.capabilities;
    dispatch(new SetLoading(true));
    const details = yield CardIssuingApiService.getIssuingDetails(id, true, true);
    dispatch(new SetCardDetails(details));
    if (isGatewayCardOrProgram(details) && !capabilitiesMap[details.parent_linked_account_id]) {
        const capabilities = yield LinkedAccountsApiService.getAccountCapabilities(details.parent_linked_account_id);
        dispatch(new AddCapabilities({ [details.parent_linked_account_id]: capabilities }));
    }
    dispatch(new SetLoading(false));
});
export const getTransactions = (dispatch) => (id, page, pageSize, state, sortField, sortDirection, forPersonalCard) => __awaiter(void 0, void 0, void 0, function* () {
    // get transactions based on feature flag
    let transactions;
    // don't show duplicates
    const allStates = [...CARD_TX_STATE_VALUES].filter((cardTxState) => cardTxState !== CARD_TX_STATE.DUPLICATE);
    // get combined transactions to support new expense modal
    let stateFilter;
    if (!state || state === 'all') {
        stateFilter = allStates;
    }
    else if (state !== 'default') {
        stateFilter = [state];
    }
    const searchParams = {
        limit: pageSize,
        offset: page * pageSize,
        filters: Object.assign({ 
            // filter by only the selected card id
            linked_account_ids: [id] }, (stateFilter ? { status: stateFilter } : {})),
        sort: sortField || 'posted_date',
        direction: sortDirection || 'desc'
    };
    transactions = yield TransactionsApi.getCombinedTransactions(searchParams, 'search', null, forPersonalCard);
    dispatch(new SetCardTransactions(transactions.rows, transactions.count));
});
export const suspend = (dispatch) => (id) => __awaiter(void 0, void 0, void 0, function* () {
    dispatch(new SetLoading(true));
    const updatedCard = yield LinkedAccountsApiService.suspendCard(id);
    dispatch(new SetCardState(updatedCard.state));
    toast.success('This card has been suspended!');
    dispatch(new SetLoading(false));
});
export const unsuspend = (dispatch) => (id) => __awaiter(void 0, void 0, void 0, function* () {
    dispatch(new SetLoading(true));
    const updatedCard = yield LinkedAccountsApiService.unsuspendCard(id);
    dispatch(new SetCardState(updatedCard.state));
    toast.success('This card has been unsuspended!');
    dispatch(new SetLoading(false));
});
export const cancel = (dispatch) => (id, name) => dispatch(new ShowModal(CancelCardModal, { cardName: name, cardId: id }));
export const edit = (id, card) => (dispatch, getState) => __awaiter(void 0, void 0, void 0, function* () {
    const capabilitiesMap = getState().cards.capabilities;
    const capabilities = capabilitiesMap[card.parent_linked_account_id];
    if (isGatewayCardOrProgram(card)) {
        dispatch(new ShowModal(CardsGatewayIssuingModalConnected, {
            parentLinkedAccountId: card.parent_linked_account_id,
            linkedAccountId: id,
            companyId: window.USER_PROFILE.company_id,
            capabilities,
            onSubmit: ( /* updatedCard: ILinkedAccountModel */) => dispatch(init(id))
        }));
    }
});
export const remove = (id) => (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    dispatch(new ShowModal(ConfirmModal, {
        cancelText: 'No, Cancel',
        confirmText: 'Yes, Remove Card',
        onConfirm: () => __awaiter(void 0, void 0, void 0, function* () {
            try {
                yield LinkedAccountsApiService.deleteCard(id);
                toast.success('Card unassigned and deleted');
                window.location.href = '/cards';
            }
            catch (error) {
                const errorMessage = parseAndGetErrorMessage(error.message);
                toast.error(errorMessage);
                dispatch(new CloseModal());
            }
        }),
        children: null
    }));
});
export const viewTrackingDetails = (card) => (dispatch, getState) => __awaiter(void 0, void 0, void 0, function* () {
    dispatch(new ShowModal(CardTrackingDetailsModal, { card, shippingInfo: card.shipping }));
});
